import { useMutation } from "@tanstack/react-query";
import { forgotPwd } from "../../apis/auth";

export function useForgotPassword() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      email,
      mode,
    }: {
      email: string;
      mode?: "business" | "rn";
    }) => {
      return forgotPwd(email, mode);
    },
  });

  return {
    forgotPassword: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
